<div class="sample froala-editor">
  <div class="container">
    <div [hidden]="headerShow">
      <app-header
        *ngIf="!studentWorkReview"
        [showNotificationBtn]="showNotificationBtn"></app-header>
    </div>

    <app-loader *ngIf="loading"></app-loader>

    <div *ngIf="!studentWorkReview && !loading && headerShow">
      <div class="froala-editor-top position-relative purple-dark">
        <div *ngIf="document" class="document-info">
          <p>
            <b>Автор: </b>
            {{ document.author?.full_name }}
            ({{ document.created_at | date: 'dd.MM.YYYY HH:mm' }})
          </p>

          <p *ngIf="document.last_author">
            <b>Последнее изменение: </b>

            <span>
              {{ document.last_author }}
              ({{ document.updated_at | date: 'dd.MM.YYYY HH:mm' }})
            </span>
          </p>
        </div>

        <ng-container [ngSwitch]="isEdit">
          <ng-container *ngSwitchCase="true">
            <div
              *appCheckPermissions="whoCanEdit"
              class="d-flex justify-content-center"
              [ngClass]="titleError ? 'title-field-wrap-error' : ''">
              <mat-form-field class="col-10 col-md-7" appearance="outline">
                <input
                  matInput
                  [value]="title"
                  (keyup)="changeTitleHandler($event)" />
                <mat-hint *ngIf="titleError">{{ titleError }}</mat-hint>
              </mat-form-field>

              <div class="spinner-wrap">
                <div *ngIf="updateLoading" class="position-relative">
                  <mat-spinner diameter="22"></mat-spinner>
                </div>

                <div
                  *ngIf="!updateLoading && !titleError"
                  class="position-relative">
                  <mat-icon class="check-icon">check</mat-icon>
                </div>

                <div *ngIf="titleError" class="position-relative">
                  <mat-icon class="error-title-field">error_outline</mat-icon>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <h4 *ngIf="!studentWorkReview" class="froala-editor-title">
              {{ title }}
            </h4>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="showPenToEdit">
          <app-action-button-or-link
            *appCheckPermissions="whoCanEdit"
            [iconName]="!isEdit ? 'edit' : 'remove_red_eye'"
            [classNames]="['froala-editor-btn-mode']"
            (clickHandler)="changeEditModeStatus()"
            [tooltipLabel]="
              !isEdit
                ? 'Перейти в режим редактирования'
                : 'Выйти из режима редактирования'
            ">
          </app-action-button-or-link>
        </ng-container>
      </div>
    </div>

    <div *ngIf="whoCanEdit.includes('teachers')">
      <div *ngIf="isEdit && !loading">
        <button
          *appCheckPermissions="whoCanEdit"
          [matMenuTriggerFor]="menu"
          type="button"
          class="bg-none border info-btn"
          matTooltip="Пояснение к вставленным картинкам в редактор">
          <mat-icon class="text-error fs-1">notification_important</mat-icon>
        </button>
      </div>
    </div>

    <mat-menu
      #menu="matMenu"
      class="p-3 results-info-menu"
      xPosition="after"
      [class]="
        (UIThemeService.purpleDarkThemeFieldPanel() | async)
          ? 'purple-dark-mat-menu'
          : ''
      ">
      <p>
        Если копировать/вставлять рецензии/материалы
        <strong>из Google Doc</strong>, где есть сразу много картинок, то на
        текущий момент они не подгружаются на S3 и ссылки на картинки в рецензии
        остаются от Google Doc.
      </p>
      <p>
        Вставка одной картинки работает стабильно или если рецензию писать сразу
        в CRM
      </p>
      <p>
        <strong
          >* Есть вероятность 50/50, что студенты могут не увидеть данные
          картинки</strong
        >
        т.к у них нету доступа к диску, где лежат материалы.
        <strong
          >Наблюдаем и пытаемся решить данную проблему, приносим извинения за
          временные неудобства.</strong
        >
      </p>
    </mat-menu>
    <div *ngIf="!loading" class="froala-editor-wrap">
      <div
        class="froala-editor-space"
        [className]="isMaterial ? 'watermarked' : ''">
        <ng-container *appCheckPermissions="whoCanEdit">
          <div
            *ngIf="isEdit"
            [froalaEditor]="options"
            [(froalaModel)]="content"
            (froalaModelChange)="updateMaterial()"
            #froalaEditor></div>
        </ng-container>

        <div
          class="froala-view p-4 content overflow-auto"
          [ngStyle]="{ height: windowHeight !== null ? windowHeight : '' }"
          *ngIf="!isEdit"
          [froalaView]="content"></div>
      </div>
    </div>
  </div>
</div>
